import React from "react";
import { styled } from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import DataObjectIcon from '@mui/icons-material/DataObject';
import SettingsIcon from '@mui/icons-material/Settings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { CampaignOutlined, CategoryRounded, CellTowerOutlined, DataArray, DataObject, GroupAddOutlined, HelpCenterOutlined, LockClockOutlined, ScatterPlot } from "@mui/icons-material";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import SchoolIcon from '@mui/icons-material/School';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import GroupIcon from '@mui/icons-material/Group';



export const drawerWidth = 240;

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
  },
  
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

export const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  });

export const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      }),
      ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      }),
    }),
  );

  export const LOCATION_ROOT = {
    'Home': {item: 0, icon: <HomeIcon />},
    'User': {item: 1, icon: <GroupIcon />},
    'Location': {item: 2, icon: <LocationCityIcon />},
    'Curriculum': {item: 3, icon: <SchoolIcon />},
    'StudentData': {item: 4, icon: <DataArray />},
    'TutorData': {item: 5, icon: <DataObject />},
    'Settings': {item: 6, icon: <SettingsIcon />}  
  } 

  export const LOCATION_ADMIN = {
    'Home': {item: 0, icon: <HomeIcon /> },
    'Location': {item: 1, icon: <LocationCityIcon />},
    'Curriculum': {item: 2, icon: <SchoolIcon />},
    'StudentData': {item: 3, icon: <DataArray />},
    'TutorData': {item: 4, icon: <DataObject />},
    'Analytics': {item: 5, icon: <ScatterPlot />},
    'Settings': {item: 6, icon: <SettingsIcon />}  
  }
  export const LOCATION_TUTOR = {
    'Home': {item: 0, icon: <HomeIcon />},
    'TrackSession': {item: 1, icon: <LockClockOutlined /> },
    'Announcements': {item: 2, icon: <CampaignOutlined /> },
    'Assessments sessions': {item: 2, icon: <CellTowerOutlined /> },
    'Assessments': {item: 3, icon: <AssessmentIcon /> },
    'Material': {item: 4, icon: <CategoryRounded />},
    'Sessions': {item: 5, icon: <FormatListNumberedIcon />},
    'Students': {item: 6, icon: <GroupAddOutlined />},
    'Help': {item: 7, icon: <HelpCenterOutlined />},

  }
